<template>
  <main class="bg-[#FFFCF9]">
    <section class="relative overflow-hidden border-b border-orange-100 bg-white">
      <div class="absolute inset-0 bg-gradient-to-br from-brand/10 via-transparent to-pink-50"></div>
      <div class="relative mx-auto max-w-6xl px-4 py-14 text-center lg:px-8 lg:py-20">
        <span class="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand text-2xl text-white shadow-lg">
          <i class="ri-customer-service-2-line"></i>
        </span>
        <p class="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-brand">Invi8 support</p>
        <h1 class="mt-3 text-3xl font-bold text-ink sm:text-4xl">How can we help?</h1>
        <p class="mx-auto mt-3 max-w-2xl text-base leading-7 text-muted">
          Find quick answers or contact the Invi8 team for help with your account, invitations, events, and albums.
        </p>
      </div>
    </section>

    <section class="mx-auto max-w-6xl px-4 py-10 lg:px-8 lg:py-14">
      <div class="grid gap-5 md:grid-cols-2">
        <RouterLink
          to="/faqs"
          class="group rounded-3xl border border-gray-100 bg-white p-6 shadow-card transition hover:-translate-y-1 hover:border-orange-200 hover:shadow-lg"
        >
          <span class="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-xl text-brand">
            <i class="ri-question-answer-line"></i>
          </span>
          <h2 class="mt-5 text-xl font-bold text-ink">Browse FAQs</h2>
          <p class="mt-2 text-sm leading-6 text-muted">Get answers about events, guest access, albums, privacy, and common account questions.</p>
          <span class="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand">
            View answers <i class="ri-arrow-right-line transition group-hover:translate-x-1"></i>
          </span>
        </RouterLink>

        <RouterLink
          to="/contact"
          class="group rounded-3xl border border-gray-100 bg-white p-6 shadow-card transition hover:-translate-y-1 hover:border-orange-200 hover:shadow-lg"
        >
          <span class="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-pink-50 text-xl text-brand">
            <i class="ri-mail-send-line"></i>
          </span>
          <h2 class="mt-5 text-xl font-bold text-ink">Contact support</h2>
          <p class="mt-2 text-sm leading-6 text-muted">Send the team your issue and include the account or event details needed to investigate it.</p>
          <span class="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand">
            Send a message <i class="ri-arrow-right-line transition group-hover:translate-x-1"></i>
          </span>
        </RouterLink>
      </div>

      <div class="mt-8 rounded-3xl border border-gray-100 bg-gray-50 p-6 sm:p-8">
        <div class="grid gap-6 md:grid-cols-[1fr_auto] md:items-center">
          <div>
            <p class="text-xs font-bold uppercase tracking-[0.16em] text-brand">Before contacting us</p>
            <h2 class="mt-2 text-xl font-bold text-ink">Include the right details</h2>
            <p class="mt-2 max-w-2xl text-sm leading-6 text-muted">
              Add your event name and date for invitation issues, or the email linked to your account for profile and access problems.
            </p>
          </div>
          <a
            href="mailto:support@invi8.com"
            class="inline-flex items-center justify-center gap-2 rounded-full bg-brand px-5 py-3 text-sm font-bold text-white shadow-lg transition hover:bg-brandDark"
          >
            <i class="ri-mail-line"></i> support@invi8.com
          </a>
        </div>
      </div>

      <div class="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-muted">
        <RouterLink to="/privacy-policy" class="transition hover:text-brand">Privacy Policy</RouterLink>
        <RouterLink to="/terms" class="transition hover:text-brand">Terms &amp; Conditions</RouterLink>
      </div>
    </section>
  </main>
</template>

<script setup>
import { useSeoMeta } from '@/utils/seo'

useSeoMeta({
  title: 'Support Center',
  description: 'Get support for Invi8 accounts, invitations, events, albums, guest access, vendor listings, and common troubleshooting questions.',
  path: '/support'
})
</script>
